import { Box } from "@mui/material";
import { ButtonCus } from "components/ButtonCus";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { InputOutLine } from "components/InputCus";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { loginSchema } from "utils";
import { FormLogin } from "types";
import { useAuthentication } from "hooks";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { Icons } from "assets";
import Websocket from 'ws'

const Login = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const {
    control,
    handleSubmit,
    getValues,
    formState: { errors },
  } = useForm<FormLogin>({
    resolver: yupResolver(loginSchema) as any,
    mode: "onChange",
    defaultValues: {
      email: "",
      password: "",
    },
  });
  const wsRef = useRef({ ws: null }).current

  const { onLogin } = useAuthentication();
  const handleClick = useCallback((data: FormLogin) => {
    // loginMutation.mutate(data);
    onLogin(data)
    console.log("🚀 ~ handleClick ~ data:", data)
    wsRef.ws.send({
      "asset_index": 1
    })
  }, []);

  useEffect(() => {
    function connectWebSocket() {

      wsRef.ws = new WebSocket('wss://ws.derivws.com/websockets/v3?app_id=80384');
      const token = 'RhSiCWRa8LjZaBN'
      wsRef.ws.onopen = () => {
        wsRef.ws.send(JSON.stringify({ authorize: token }));
      };

      wsRef.ws.onmessage = (message) => {
        const data = JSON.parse(message.data);
        console.log("🚀 ~ connectWebSocket ~ data:", data)
      };

      wsRef.ws.onerror = (error) => {
        console.log("🚀 ~ connectWebSocket ~ error:", error)
      };

      wsRef.ws.onclose = () => {
        console.log("🚀 ~ connectWebSocket ~ onclose:")

      };
    }
    connectWebSocket()
  }, []);

  const [showPassword, setShowPassword] = useState(false);
  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  return (
    <Box
      flex={1}
      display={"flex"}
      alignItems={"center"}
      justifyContent={"space-center"}
      flexDirection={"column"}
      width={"100%"}
      maxWidth={"500px"}
      height={"500px"}
      padding={"20px"}
      sx={{
        overflowY: "auto",
        mx: "auto",
        border: "1px solid #ccc",
        pt: "30px",
        borderRadius: "10px",
      }}
    >
      {/* <Box
        mb={3}
        gap={"6px"}
        display={"flex"}
        alignItems={"center"}
        justifyContent={"center"}
        px={"15px"}
        fontSize={24}
        component={"h1"}
      >
        Administrator
      </Box> */}

      <Box
        flex={0.5}
        width={"100%"}
        px={"15px"}
        mt={7}
        component="form"
        onSubmit={handleSubmit(handleClick)}
      >
        <Box>
          <Controller
            name="email"
            control={control}
            render={({ field }) => (
              <InputOutLine
                type="text"
                label="メールアドレス"
                {...field}
                value={field.value}
                setValue={field.onChange}
                fullWidth
                error={!!errors.email}
                errorMessage={errors?.email?.message}
              />
            )}
          />
        </Box>
        <Box mt={1}>
          <Controller
            name="password"
            control={control}
            render={({ field }) => (
              <InputOutLine
                label="パスワード"
                type={showPassword ? "text" : "password"}
                value={field.value}
                setValue={field.onChange}
                error={!!errors.password}
                errorMessage={errors.password?.message}
                fullWidth
                icon={<>{showPassword ? <Icons.Eye /> : <Icons.EyeHide />}</>}
                onClickIcon={handleClickShowPassword}
              />
            )}
          />

        </Box>
        <Box mt={2}>
          <Box
            mt={15}
            display={"flex"}
            alignItems={"center"}
            justifyContent={"center"}
          >
            <ButtonCus
              title="ログイン"
              // isLoading={loginMutation.isPending}
              LabelProps={{ variant: "bodyBold" }}
              useI18n
              sx={{
                width: "100%",
                borderRadius: "5px !important",
                height: "50px !important",
              }}
              variant={"text"}
              type="submit"
            />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default Login;
